export default __webpack_public_path__ + "static/media/favoritesRed.fecf5f9e.svg";